export const FAQ_TOP_CATEGORY_ID = 1;
